export const FOLLOWUP_REMINDER = "clinic/v2/appointments/followup_reminder";
